/**
 * Asteroid sizes configuration
 *
 * This file is auto-generated by the balance importer.
 * Do not edit manually - changes will be overwritten.
 *
 * Generated at: 2025-09-25T12:43:18.991Z
 */

import { ConfigType } from './ConfigType';

export interface AsteroidSizeConfig {
  size_id: string;
  name: string;
  size_hp_mult: number;
  size_value_mult: number;
  frag_count: number;
  child_size: string;
  configType: ConfigType.ASTEROID_SIZES;
}

export const asteroidsSizeData: Record<string, AsteroidSizeConfig> = {
  SZ_PEB: {
    size_id: 'SZ_PEB',
    name: 'Pebble',
    size_hp_mult: 0.5,
    size_value_mult: 0.5,
    frag_count: 0,
    child_size: '–',
    configType: ConfigType.ASTEROID_SIZES,
  },
  SZ_S: {
    size_id: 'SZ_S',
    name: 'Small',
    size_hp_mult: 0.7,
    size_value_mult: 1,
    frag_count: 2,
    child_size: 'SZ_PEB',
    configType: ConfigType.ASTEROID_SIZES,
  },
  SZ_M: {
    size_id: 'SZ_M',
    name: 'Medium',
    size_hp_mult: 0.9,
    size_value_mult: 1.2,
    frag_count: 2,
    child_size: 'SZ_S',
    configType: ConfigType.ASTEROID_SIZES,
  },
  SZ_L: {
    size_id: 'SZ_L',
    name: 'Large',
    size_hp_mult: 1.5,
    size_value_mult: 1.5,
    frag_count: 3,
    child_size: 'SZ_M',
    configType: ConfigType.ASTEROID_SIZES,
  },
  SZ_C: {
    size_id: 'SZ_C',
    name: 'Colossal',
    size_hp_mult: 2,
    size_value_mult: 2,
    frag_count: 4,
    child_size: 'SZ_L',
    configType: ConfigType.ASTEROID_SIZES,
  },
};

/**
 * Get AsteroidSizeConfig by size_id
 */
export function getAsteroidsSize(id: string): AsteroidSizeConfig | undefined {
  return asteroidsSizeData[id];
}

/**
 * Get all AsteroidSizeConfig entries
 */
export function getAllAsteroidsSize(): AsteroidSizeConfig[] {
  return Object.values(asteroidsSizeData);
}

/**
 * Check if AsteroidSizeConfig exists
 */
export function hasAsteroidsSize(id: string): boolean {
  return id in asteroidsSizeData;
}
